import { FC, useMemo } from "react";
import useEvent from "react-use-event-hook";
import { useRecoilState } from "recoil";

import { SVG_MUI } from "@ryde/assets";
import { CheckboxControlledMui, useDraggableActivator } from "@ryde/controls";
import { useMapColors, usePageContext } from "@ryde/redux";
import { isSelectedIdSF } from "@ryde/shared";
import { blueGreyMui } from "@ryde/theme";

import { IRidesKanbanDragOrSelectHandle } from "./rides.kanban.drag-or-select-handle.models";

export const RidesKanbanDragOrSelectHandleInteractive: FC<
  IRidesKanbanDragOrSelectHandle
> = ({ rideDto }) => {
  const { entity } = usePageContext();
  const { listeners, setActivatorNodeRef } = useDraggableActivator();

  const [isSelected, setIsSelected] = useRecoilState(
    isSelectedIdSF([entity, rideDto.id]),
  );

  const handleSelectToggle = useEvent((): void => {
    setIsSelected(selected => !selected);
  });

  const { getMapColorByRideId } = useMapColors();

  const gripColor = useMemo(() => {
    return isSelected ? getMapColorByRideId(rideDto.id) : blueGreyMui._200;
  }, [rideDto.id, getMapColorByRideId, isSelected]);

  return (
    <>
      <button className="dragButton" ref={setActivatorNodeRef}>
        <SVG_MUI.GripVerticalColoredSVG
          className="pointer"
          fill={gripColor}
          data-e2e="drag-grip-vertical"
          {...listeners}
        />
      </button>
      <CheckboxControlledMui
        width={15}
        height={15}
        checked={isSelected}
        setCheckedToggle={handleSelectToggle}
        e2eData="kanban-item-selected-checkbox"
      />
    </>
  );
};
